import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import PropTypes from "prop-types";
// import styles from "./style/DeleteLectureButton.module.css";

const DeleteLectureModal = (props) => {
  const { onDelete, children } = props;
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleSubmit = () => {
    onDelete && onDelete();
    handleClose();
  };

  return (
    <>
      <div onClick={handleShow}>{children}</div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure want to delete lecture?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancle
          </Button>
          <Button onClick={handleSubmit}>Delete</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

/* required: display name */
DeleteLectureModal.displayName = "DeleteLectureModal";

/* required: props types */
DeleteLectureModal.propTypes = { onDelete: PropTypes.func };

/* required: default props */
DeleteLectureModal.defaultProps = { onDelete: () => {} };

export { DeleteLectureModal };
